<section class="facet-filter">
  <h3 class="facet-subtitle" [attr.aria-label]="'adura.matrix.label' | translate">{{ 'adura.matrix.label' | translate }}</h3>
  <div>
    <div class="form-group input-reset-button" *ngIf="this.matrix && this.matrix?.length > 0">
      <input class="form-control input-sm" spellcheck="false" [(ngModel)]="searchTerm"
             (ngModelChange)="searchMatrix()" placeholder="{{ 'adura.matrix.search' | translate }}"/>
      <button type="reset">
        <i class="fa fa-times" aria-hidden="true" (click)="clearInput()"></i>
      </button>
    </div>
    <ng-container *ngIf="!this.matrixListToShow() || this.matrixListToShow().length === 0">
      <p><small>{{ 'search.noFilter' | translate }}</small></p>
    </ng-container>
    <nav [attr.aria-label]="'adura.matrix.list' | translate">
      <ul class="list-inline tags">
        <ng-container *ngFor="let matrix of this.matrixListToShow()">
          <li class="nav-item filter-tag" [ngClass]="(isMatrixActive(matrix.id))?'active':''">
            <a (click)="changeMatrix(matrix.id)" role="button" class="filter-tag-label"
               [attr.aria-pressed]="(isMatrixActive(matrix.id))?'true':'false'"
               [attr.aria-label]="('adura.matrix.label' | translate) + ': ' + matrix.name + ', ' +
             ('global.total' | translate) + ': ' + matrix.count">{{ matrix.name }}
              <small [attr.aria-label]="matrix.count" aria-hidden="true">{{ matrix.count }}</small></a></li>
        </ng-container>
      </ul>
    </nav>

    <ng-container *ngIf="(top10Length > 9)">
      <p><a (click)="changeShowMoreMatrix()" class="btn btn-xs">
        <ng-container *ngIf="isShowMoreMatrix(); then showmore else showless"></ng-container>
        <ng-template #showmore>
          <i class="fa filter-more-less fa-angle-up"></i>{{ 'global.show.less' | translate }}
        </ng-template>
        <ng-template #showless>
          <i class="fa filter-more-less fa-angle-down"></i>{{ 'global.show.more' | translate }}
        </ng-template>
      </a>
      </p>
    </ng-container>
  </div>
</section>
